import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import CircularProgress from "@material-ui/core/CircularProgress";


import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableFooter,
  TableRow,
  TablePagination,
  Typography,
  IconButton,
  Paper
} from "@material-ui/core";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import SortLabel from "../Common/SortLabel";

// import CssBaseline from '@material-ui/core/CssBaseline';
import { useSelector } from "react-redux";
import axios from "axios";
import envConfig from "../../bin/env.config";
import ButtonAdd from "./Products/ButtonAdd";
import ButtonEdit from "./Products/ButtonEdit";
import ButtonLlmSettings from "./Products/ButtonLlmSettings";
import ButtonDelete from "./Products/ButtonDelete";
import ButtonHidden from "./Products/ButtonHidden";
import ButtonProductNote from "./Products/ButtonProductNote";
// import ButtonCalculateMatches from "./Products/ButtonCalculateMatches";
// import CountCompetitorProducts from "./Products/CountCompetitorProducts";
// import CountBProducts from "./Products/CountBProducts";
import SearchBox from "./Products/SearchBox";
// import CountSProductsInCProduct from "./Products/CountSProductsInCProduct";
// import CountBannersInCProduct from "./Products/CountBannersInCProduct";
import BProductsPanel from "./Products/BProductsPanel";
import CompetitorsPanel from "./Products/CompetitorsPanel";
// import ButtonSummary from "./Projects/ButtonSummary";
// import ButtonSync from "./Projects/ButtonSync";
// import ButtonSelectBanners from "./Projects/ButtonSelectBanners";
// import ButtonSelectCities from "./Projects/ButtonSelectCities";
import ButtonMetrics from "./Projects/ButtonMetrics";
import ButtonConfig from "./Projects/ButtonConfig";
import ButtonProductNoteReport from "./Projects/ButtonProductNoteReport";
import ButtonNote from "./Projects/ButtonNote";
import ButtonImportCSV from "./Products/ButtonImportCSV";
import ButtonAutoMap from "./Products/ButtonAutoMap";
import BPotentialPanel from "./Products/BPotentialPanel";



const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  searchContainer: {
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(1),
    },
  },
  table: {
    minWidth: 350,
    // "& tbody>.MuiTableRow-root:hover": {
    //   background: "#DDD",
    // },
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  title: {
    flexGrow: 1,
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
}));

export function RowItem(props){
  const {item, i, doReloadData,expanded, showPotential, searchText,projectId, page, rowsPerPage} = props;
  const [isExpanded, setIsExpanded] = useState(expanded);
  const [reloadDataCount, setReloadDataCount] = useState(0);
  
  useEffect(() => {
    //regenerate document;
    setIsExpanded(expanded)
  }, [expanded]);
  const doReloadCount = ()=>{
    setReloadDataCount(prev => prev + 1)
  }
  return (
    <>
      <TableRow style={{background:'#f0f0f3'}} key={item.id}  >
        <TableCell title={item.id+' - '+item.name} align="center" rowSpan={isExpanded ? (showPotential ? 4 : 3) : 1} style={{background:i%2?'#eafaea':'#e6ecff',cursor:'pointer',width:'50px'}} onClick={()=>setIsExpanded(!isExpanded)} >
            {page * rowsPerPage + i + 1}         
        </TableCell>
        <TableCell align="left" style={{width:'120px'}}>
          <ButtonEdit product={item} reloadData={doReloadData}/> 
          <ButtonLlmSettings product={item} project_id={projectId} reloadData={doReloadData}/>
          <ButtonDelete product={item} reloadData={doReloadData}/> 
          <ButtonHidden product={item} reloadData={doReloadData}/> 
          <ButtonAdd product={item} reloadData={doReloadCount}/> 
        </TableCell>                   
        <TableCell align="left">{item.id}</TableCell>
        <TableCell align="left">{item.name} <ButtonProductNote productId={item.id}/> <br/>
        <i style={{fontSize:"0.8em"}}><b>Key words:</b> {item.key_words}</i>
        {item.description ? (
          <>
            <br/>
            <i style={{fontSize:"0.8em", whiteSpace:"pre-wrap"}}><b>Description:</b> {item.description}</i>
          </>
        ) : null}
        {(item.number_pmg_need > 1 || item.llm_meta) ? (
          <>
            <br/>
            <i style={{fontSize:"0.8em"}}>
              <b>PMG:</b> {(item.products?.length ?? 0)}/{item.number_pmg_need ?? 1}
              {item.llm_meta?.product_name ? (
                <> · <b>LLM:</b> {item.llm_meta.product_name}{item.llm_meta.size ? ` ${item.llm_meta.size}` : ""}</>
              ) : null}
            </i>
          </>
        ) : null}
        </TableCell>
        {/* <TableCell align="left">{row.type}</TableCell> */}
        <TableCell align="left">{item.category}</TableCell>
        {/* <TableCell align="left">{item.sub_category}</TableCell> */}
        {/* <TableCell align="left">{row.standard_size}</TableCell>
        <TableCell align="left">{row.actual_size}</TableCell> */}
        {/* <TableCell align="center">
          <CountBProducts companyReportToolProductId={row.id}/> 
        </TableCell> */}
        {/* <TableCell align="center">
          <CountCompetitorProducts companyReportToolProductId={row.id}/> 
        </TableCell> */}
        <TableCell style={{width:'68px'}}  align="center">
          {/* <CountSProductsInCProduct cproductId={item.id}/>  */}
        </TableCell>
        <TableCell style={{width:'68px'}}  align="center">
          {/* <CountBannersInCProduct cproductId={item.id}/> */}
        </TableCell>
      </TableRow> 
      {isExpanded&&(
        <>
        {showPotential&&(
        <TableRow style={{backgroundColor:'#f5f5a44d'}} >
          <TableCell colSpan={8}>
            {/* show potential to map  */}
            <BPotentialPanel item={item} reloadDataCount={reloadDataCount} setReloadDataCount={setReloadDataCount} searchText={searchText} projectId={projectId}/>
          </TableCell>
        </TableRow>
        )}
        <TableRow >
          <TableCell colSpan={8}>
            <BProductsPanel item={item} reloadDataCount={reloadDataCount} searchText={searchText} projectId={projectId}/>
          </TableCell>
        </TableRow>
        <TableRow >
          <TableCell colSpan={8}>
            <CompetitorsPanel cproductId={item.id} reloadData={doReloadData}/>
          </TableCell>
        </TableRow>
        </>
      )}                        
    </>
  )
}
export default function CompanyReportToolProductPage(props) {
  const history = useHistory();
  const classes = useStyles();  
  const projectId = props.match.params.id;
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id")
  const [dataSource, setDataSource] = useState([]);
  const [project, setProject] = useState(null);
  const [reloadData, setReloadData] = useState(0);
  const [searchText, setSearchText] = useState('');  
  const [searchProjectProductOnly, setSearchProjectProductOnly] = useState(true);
  const [searchIsHidden, setSearchIsHidden] = useState(2);
  const [notMappedYet, setNotMappedYet] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [showPotential, setShowPotential] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const token = useSelector((state) => state.session.token);
  
  // const loader = document.querySelector(".loader");
  // const showLoader = () => loader.classList.remove("loader--hide");

  // const hideLoader = () => {
  //   loader.classList.add("loader--hide");
  //   // updateContainer.classList.add("loader--hide");
  // };
  const doReloadData =()=>{setReloadData(prev => prev + 1); setPage(0)}
  useEffect(() => {
    const fetchProject = async () => {
      setIsLoading(true);
      const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/project/${projectId}`;
      const result = await axios.get(url, {
        headers: {
          Authorization: token,
        },
      });
      setProject(result.data.data);
      setIsLoading(false);
    };
    if (projectId && token) {
      fetchProject();
    }
  },[projectId, token]);
  
  
  useEffect(() => {
    
    const fetchData = async () => {
      // showLoader();
      setIsLoading(true);
      try {
        const skip = page * rowsPerPage;
        const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/products?project_id=${projectId}&orderBy=${orderBy}&order=${order}&limit=${rowsPerPage}&skip=${skip}`;
        const result = await axios.post(url,
          {q:searchText,notMappedYet:notMappedYet,searchIsHidden:searchIsHidden}
          , {
          headers: {
            Authorization: token,
          },
        });
        
        setDataSource(result.data.data);
        // If API returns total count, use it; otherwise estimate from data length
        if (result.data.total !== undefined) {
          setTotalCount(result.data.total);
        } else if (result.data.count !== undefined) {
          setTotalCount(result.data.count);
        } else {
          // Estimate: if we got full page, there might be more
          setTotalCount(result.data.data.length < rowsPerPage ? (page * rowsPerPage + result.data.data.length) : (page + 1) * rowsPerPage + 1);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setDataSource([]);
        setTotalCount(0);
      } finally {
        setIsLoading(false);
        // hideLoader();
      }
    };
    if (projectId && token) {
      fetchData();
    }
  
}, [notMappedYet, searchIsHidden, order, orderBy, reloadData, searchText, page, rowsPerPage, projectId, token]);
const handleSort=(column)=>{
  setOrder(order==='desc'?'asc':'desc');
  setOrderBy(column);
  setPage(0);  
}
const handleSearchIsHiddenChange = (event) => {
  setSearchIsHidden(event.target.value);
};
const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
};

const handlePageSelect = (event) => {
  setPage(parseInt(event.target.value, 10));
};

const doSearch = (searchValue) => {
  setSearchText(searchValue);
  setPage(0);
};
  return (
    <>
     {/* <CssBaseline /> */}
      <AppBar position="sticky" color="inherit">
        <Toolbar>
          <IconButton
            color="inherit"
            onClick={() => history.goBack()}
            aria-label="Close"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography className={classes.title} variant="h6" noWrap>
            Products of the project {project&&project.name}
          </Typography>  
          {/* <ButtonEdit project={row} reloadData={doReloadData}/>  */}
          {project&&<ButtonProductNoteReport projectId={project.id} />}
          {project&&<ButtonNote projectId={project.id} />}
          {project&&<ButtonConfig project={project} />}
          {project&&<ButtonMetrics project={project} />}
          {project&&<ButtonAutoMap project={project} />}
          
        </Toolbar>
      </AppBar>
      
        <Grid
          className={classes.searchContainer}
          container
          direction="column"
          spacing={2}
        >
          <Grid item container justifyContent="center" alignItems="center">
          <Select  value={searchIsHidden} onChange={handleSearchIsHiddenChange}>
              <MenuItem value="0">
                <em>All Products</em>
              </MenuItem>
              <MenuItem value="1">
                <em>Hidden Products</em>
              </MenuItem>
              <MenuItem value="2" >
                <em>Unhidden Products</em>
              </MenuItem>
            </Select>
            <FormControlLabel
              control={
                <Checkbox
                    checked={notMappedYet}
                    onChange={() => setNotMappedYet(!notMappedYet)}
                    name="Not mapped yet"
                    color="secondary"
                  />
                }
                label="Not mapped yet"
             />
             <FormControlLabel
              control={
                <Checkbox
                    checked={showPotential}
                    onChange={() => setShowPotential(!showPotential)}
                    name="Show Potential"
                    color="secondary"
                  />
                }
                label="Show Potential"
              />
            <FormControlLabel
              control={
                <Checkbox
                    checked={searchProjectProductOnly}
                    onChange={() => setSearchProjectProductOnly(!searchProjectProductOnly)}
                    name="Product Only"
                    color="secondary"
                  />
                }
                label="Product Only"
              />
              
              <SearchBox value={searchText} doSearch={doSearch} searchOnChange={false} placeholder="Search"/>
          </Grid>          
        </Grid>
        <Grid
        className={classes.root}
        container
        alignItems="center"
        justifyContent="center"
      >
          
        <TableContainer component={Paper}>
          <Grid container alignItems="center" style={{ padding: '8px' }}>
            <ButtonEdit project_id={projectId} reloadData={doReloadData}/> 
            &nbsp;  
            <ButtonImportCSV project_id={projectId} reloadData={doReloadData}/> 
            {/* &nbsp;      
            <ButtonCalculateMatches project_id={projectId} flow_type="product-similarity" />   
            &nbsp;      
            <ButtonCalculateMatches project_id={projectId} flow_type="product-matching" />   */}
          </Grid>
          <Table className={classes.table} stickyHeader aria-label="simple table">
            <TableHead >
            <TableRow>
                <TableCell colSpan={8} align="center" style={{ padding: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', padding: '8px', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Typography variant="body2" style={{ whiteSpace: 'nowrap' }}>
                        Go to page:
                      </Typography>
                      <Select
                        value={page}
                        onChange={handlePageSelect}
                        style={{ minWidth: '80px' }}
                        size="small"
                        disabled={totalCount === 0 || Math.ceil(totalCount / rowsPerPage) === 0}
                      >
                        {Array.from({ length: Math.ceil(totalCount / rowsPerPage) }, (_, i) => (
                          <MenuItem key={i} value={i}>
                            {i + 1}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                    <TablePagination
                      component="div"
                      count={totalCount}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      rowsPerPageOptions={[10, 20, 50, 100]}
                    />
                  </div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="center">
                <IconButton  onClick={()=>setIsExpanded(!isExpanded)}>
                  {isExpanded&&<ExpandMoreIcon/>}
                  {!isExpanded&&<ExpandLessIcon/>}
                </IconButton>                  
                </TableCell>
                <TableCell align="left">
                  Command                
                </TableCell>
                <TableCell align="left" >                    
                  <SortLabel onClick={()=>handleSort('id')}>ID</SortLabel>
                </TableCell>                     
                <TableCell align="left" >                    
                  <SortLabel onClick={()=>handleSort('name')}>Name</SortLabel>
                </TableCell>
                {/* <TableCell align="left">
                  <SortLabel onClick={()=>handleSort('type')}>Type</SortLabel>                    
                </TableCell> */}
                <TableCell align="left">
                  <SortLabel onClick={()=>handleSort('category')}>Category</SortLabel>                    
                </TableCell>
                {/* <TableCell align="left">
                  <SortLabel onClick={()=>handleSort('sub_category')}>Sub Category</SortLabel>                    
                </TableCell> */}
                {/* <TableCell align="left">
                  <SortLabel onClick={()=>handleSort('standard_size')}>Standard Size</SortLabel>                    
                </TableCell>
                <TableCell align="left">
                  <SortLabel onClick={()=>handleSort('actual_size')}>Actual Size</SortLabel>                    
                </TableCell>     */}
                {/* <TableCell align="left">
                  # PMG Ids                   
                </TableCell> */}
                {/* <TableCell align="left">
                  # Competitor                   
                </TableCell> */}
                <TableCell align="left" style={{whiteSpace:'nowrap'}}>
                  # in Group                   
                </TableCell>
                <TableCell align="left" style={{whiteSpace:'nowrap'}}>
                  # Banners                   
                </TableCell>                
                         
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
          <TableRow>
                <TableCell colSpan={8} align="center" style={{ padding: 0 }}>
                  <CircularProgress size={16} />
                </TableCell>
              </TableRow>
          ) : (
            <>
                  {dataSource.map((row, i) => (
                    <RowItem key={i} item={row} i={i} doReloadData={doReloadData}  expanded={isExpanded} showPotential={showPotential} searchText = {searchProjectProductOnly?'':searchText} projectId={projectId} page={page} rowsPerPage={rowsPerPage}/>                
                  ))}
              </>
            )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableCell colSpan={8} align="center" style={{ padding: 0 }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', padding: '8px', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Typography variant="body2" style={{ whiteSpace: 'nowrap' }}>
                        Go to page:
                      </Typography>
                      <Select
                        value={page}
                        onChange={handlePageSelect}
                        style={{ minWidth: '80px' }}
                        size="small"
                        disabled={totalCount === 0 || Math.ceil(totalCount / rowsPerPage) === 0}
                      >
                        {Array.from({ length: Math.ceil(totalCount / rowsPerPage) }, (_, i) => (
                          <MenuItem key={i} value={i}>
                            {i + 1}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                    <TablePagination
                      component="div"
                      count={totalCount}
                      page={page}
                      onPageChange={handleChangePage}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      rowsPerPageOptions={[10, 20, 50, 100]}
                    />
                  </div>
                </TableCell>
              </TableRow>
            </TableFooter>             
          </Table>
        </TableContainer>
      </Grid>
     
    </>
  );
}
